import ConsentAnalytics from '../../components/admin/ConsentAnalytics';

export default function ConsentAnalyticsPage() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
          Cookie Consent Analytics
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Monitor user cookie consent preferences and analytics coverage
        </p>
      </div>

      <ConsentAnalytics />

    </div>
  );
}